module.exports = __webpack_public_path__ + "img/a_lacteos.3ba645d9.svg";